import { useLocalSearchParams } from 'expo-router';
import PersonDetail from '@/screens/PersonDetail';

export default function PrivateTabsOrganizationTeamMemberPersonIdIndexRoute() {
  const { personId = '' } = useLocalSearchParams<{ personId?: string }>();
  return <PersonDetail key={personId} personId={personId} />;
}
